var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar } from '@dixa/lib-shared-habla';
import autobind from 'autobind-decorator';
import noop from 'lodash/noop';
import _orderBy from 'lodash/orderBy';
import { Component } from 'react';
import { getConversationTitle } from 'app/utils/conversationTitle';
import markdownToText from 'app/utils/markdownToText';
import { analytics } from 'app/utils/segment';
import { metaConversation } from 'components/conversation/utils/conversationObjectConverters';
import { ConversationDetails, ConversationDetailsLayout, } from 'components/conversationsOverview/components/ConversationDetails';
import ActionsDropdown from '../actionsDropdown/ActionsDropdown';
import { TeamCard } from '../teamCard';
export class TeamConversation extends Component {
    constructor(props) {
        super(props);
        this.onFetchPreviewMessages = this.onFetchPreviewMessages.bind(this);
        this.state = {
            loading: false,
            texts: [],
        };
    }
    formatMessages(messages) {
        const texts = [];
        if (messages) {
            const sortedMessages = _orderBy(messages, ['created_at'], ['desc']);
            let index = 0;
            for (const message of sortedMessages) {
                if (message.attributes && typeof message.attributes.text === 'string') {
                    texts.push(markdownToText(message.attributes.text));
                    if (index >= 5) {
                        break;
                    }
                    index++;
                }
            }
        }
        return texts;
    }
    onFetchPreviewMessages(csid) {
        this.setState({ loading: true });
        this.props
            .conversationsOverviewGetMessages({ csid: parseInt(csid, 10) })
            .then(({ data }) => {
            this.setState({
                loading: false,
                texts: this.formatMessages(data.messages),
            });
        })
            .catch((e) => {
            this.setState({ loading: false, texts: [] });
            console.error('conversationsOverviewGetMessages', e);
        });
    }
    handleFetchPreviewMessages() {
        const { conversation } = this.props;
        if (conversation === null || conversation === void 0 ? void 0 : conversation.id) {
            this.onFetchPreviewMessages(conversation.id.toString());
        }
    }
    render() {
        const { csid, conversation, requester, transferToQueueModalOpen, user, profileId, } = this.props;
        const conversationTitle = getConversationTitle({
            conversation: conversation,
            requester,
        });
        if (!conversation) {
            return null;
        }
        return (_jsx(TeamCard.Person, Object.assign({ dropdown: _jsx(ActionsDropdown, { conversation: conversation, csid: csid, userId: requester && requester.id ? requester.id : null, profileId: profileId, transferToQueueModalOpen: transferToQueueModalOpen }), previewDropdownButton: null, avatar: _jsx(Avatar, { user: user }), onActionsClick: noop }, { children: _jsx(ConversationDetails, { layout: ConversationDetailsLayout.TeamConversation, conversationName: conversationTitle, metaConversation: metaConversation.from.conversation(conversation, requester), conversationUrl: `/conversation/${csid}`, onTitleClick: () => analytics.teamConversationTitleLinkClicked(), onSubTitleClick: () => analytics.teamConversationStatusLinkClicked() }) })));
    }
}
__decorate([
    autobind
], TeamConversation.prototype, "handleFetchPreviewMessages", null);
